import axiosInstance from "./instance";

const instance = axiosInstance();

export const userloginSection = async (email, password) => {
  const checkLoginMode = email.includes("@") == true ? true : false;
  const postdata =
    checkLoginMode === true
      ? JSON.stringify({ password: password, email: email })
      : JSON.stringify({
        password: password,
        mobileNumber: email,
      });
  try {
    const response = await instance.post(`/auth/login`, postdata);
    if (response.status == 200) {
      const accessTokenFromHeader = response.headers["accesstoken"];
      sessionStorage.setItem("accessToken", accessTokenFromHeader);
      sessionStorage.setItem("userId", response.data.id);
      return response;
    } else {
      return response;
    }
  } catch (error) {
    return error;
  }
};

export const handlesubmitotpapi = async (email, emailotp) => {

  const data = {
    resetToken: emailotp,
    email: email
  }
  try {
    const response = await instance.post(`/reset-password/email-validation`, data);
    return response;
  } catch (error) {
    return error;
  }
}

export const handleMobileOtpSubmit = async (mobile, mobileOtp) => {

  const data = {
    resetToken: mobileOtp,
    phoneNumber: mobile
  }
  try {
    const response = await instance.post(`reset-password/mobile-validation`, data);
    return response;
  } catch (error) {
    return error;
  }
}
export const handleApiEmailSentOtp = async (email) => {


  const data = {
    toMails: [
      email
    ]
  }
  try {
    const response = await instance.post(`reset-password/request-email-verification`, data);
    return response;
  } catch (error) {
    return error;
  }
}
export const loginapi = async (logdata) => {

  var data = {
    phoneNumberOrEmail: logdata.phoneNumberOrEmail,
    password: logdata.password
  }
  try {
    const response = await instance.post(`auth/login`, data);
    return response;
  } catch (error) {
    return error;
  }
}
export const sendMoblieOTPapi = async (value) => {
  var moblienumber = value.substring(1).replace(/ /g, "");
  const data = {
    phoneNumber: moblienumber
  }
  try {
    const response = await instance.post(`reset-password/request-mobile-verification`, data);
    return response;
  } catch (error) {
    return error;
  }
}
export const registerapi = async (data) => {
  if (!data.role) {
    data.role = "user";
  }
  if (data.phoneNumber && data.phoneNumber.startsWith("+")) {
    data.phoneNumber = data.phoneNumber.substring(1).replace(/ /g, "");
  }
  if (data.whatsappNumber && data.whatsappNumber.startsWith("+")) {
    data.whatsappNumber = data.whatsappNumber.substring(1).replace(/ /g, "");
  }

  try {
    const response = await instance.post(`auth/register`, data);
    return response;
  } catch (error) {
    return error;
  }
};
